import {getUrlParam} from '@/utils/utils';
import {Loading} from 'element-ui';

const IS_DEVELOPMENT_ENV = process.env.NODE_ENV === 'development';
const IS_PRODUCTION_ENV = process.env.NODE_ENV === 'production';

/**
 * 页面跳转
 * @param {string} pathname 路径跳转
 * @param {object} queryObj 路径跳转携带参数
 */
export function goToPage(pathname, queryObj = {}) {
  let pathSting = '';
  if (IS_DEVELOPMENT_ENV) {
    pathSting = `/${pathname}`;
  } else if (IS_PRODUCTION_ENV) {
    const path = location.pathname;
    const prefix = path.slice(0, path.lastIndexOf('/'));
    pathSting = `${prefix}/${pathname}.html`;
  }
  const queryString = Object.keys(queryObj)
    .reduce((prev, key) => [prev, `${key}=${queryObj[key]}`].join('&'), '')
    .slice(1);
  location.href = `${location.origin}${pathSting}${queryString ? `?${queryString}` : ''}`;
}

/**
 * 获取语言
 * @returns language
 */
export function getLanguage() {
  let language = localStorage.getItem('trtc-tuiPusher-language') || getUrlParam('lang') || navigator.language || 'zh';
  language = language.replace(/_/, '-').toLowerCase();

  if (language === 'zh-cn' || language === 'zh') {
    language = 'zh';
  } else if (language === 'en' || language === 'en-us' || language === 'en-GB') {
    language = 'en';
  }
  return language;
}

export function canSatisfyTRTC(vm) {
  var reValue = true;
  if (Common.browserParameters.isiOS() && parseFloat(Common.browserParameters.getIOSVersion()) < 14.3) {
    Common.PageOperator.showPromptMsg(vm, true, 'iOS版本过低，不支持连麦功能，请升级iOS系统版本', 'warning');
    reValue = false
  }
  return reValue;
}

const Common = {};
const windowHomeUrl = window.location.href;
// var str = windowHomeUrl.substring(windowHomeUrl.indexOf("/?/") + 3,windowHomeUrl.indexOf("/#/"));
// Common.agencyCode=str;
let strq = '';
if (windowHomeUrl.indexOf('/=#/') >= 0) {
  strq = windowHomeUrl.substring(windowHomeUrl.indexOf('/?/') + 3, windowHomeUrl.indexOf('/=#/'));
} else {
  strq = windowHomeUrl.substring(windowHomeUrl.indexOf('/?/') + 3, windowHomeUrl.indexOf('/#/'));
}
Common.agencyCode = strq;
Common.ios = {
  priceList: [
    1,
  ],
};

Common.browserParameters = {
  isiOS() {
    var u = navigator.userAgent;
    return u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //true是  false不是
  },
  getIOSVersion() {
    var ua = window.navigator.userAgent.toLowerCase();
    var ios = ua.match(/cpu iphone os (.*?) like mac os/);
    return ios[1].replace(/_/g, ".");//ios版本
  },
};

/**
 * 关闭标签页
 * @param vm
 * @param view
 */
Common.closeTagPage = function (vm, view) {
  vm.$store.dispatch('delVisitedViews', view).then((views) => {
    if (vm.isActive(view)) {
      const latestView = views.slice(-1)[0];
      if (latestView) {
        if (!latestView.params) {
          latestView.params = {};
        }
        latestView.params.routeByTab = true;
        vm.$router.replace(latestView);
      } else {
        const {menuNodes} = vm.$store.state.user;
        if (menuNodes && menuNodes.length > 0) {
          const url = menuNodes[0].children[0].name;// 默认第一个为首页
          vm.$router.replace({path: `/${url}`});
        }
      }
    }
  });
};

/**
 * 关闭当前页面
 * @param vm      页面对象
 * @param params  关闭页面想要跳转的页面 (String / Object)，默认为 null。
 *                String: 'path'
 *                Object: {name:'name',params:{:}}
 */
Common.closeCurrentPage = function (vm, params) {
  vm.$store.dispatch('delVisitedViews', vm.$route).then(() => {
    if (params) {
      const route = {params: {routeByTab: false, flashData: true}};
      if (Common.Util.isString(params)) {
        let name = params;
        if (params.startsWith('/')) {
          name = params.substr(1);
        }
        route.name = name;
      } else {
        Object.assign(route, params);
      }
      vm.$router.replace(route);
      return;
    }

    const {visitedViews} = vm.$store.state.tagsView;
    if (vm.$route.params && vm.$route.params.from && visitedViews.length > 0) {
      const fromView = vm.$route.params.from;
      for (const visitedView of visitedViews) {
        if (visitedView.path == fromView.path) {
          fromView.params.routeByTab = true;
          vm.$router.replace(fromView);
          return;
        }
      }
    }
    if (visitedViews.length > 0) {
      const lastView = visitedViews[visitedViews.length - 1];
      lastView.params.routeByTab = true;
      vm.$router.replace(lastView);
      return;
    }

    const {menuNodes} = vm.$store.state.user;
    if (menuNodes && menuNodes.length > 0) {
      const url = menuNodes[0].children[0].name;// 默认第一个为首页
      vm.$router.replace({path: `/${url}`});
    }
  });
};

/**
 * 打开新的标签页
 * @param vm
 * @param path
 * @param params
 * @param query
 */
Common.openTagPage = function (vm, name, params, query) {
  const data = {};
  if (name.startsWith('/')) {
    data.path = name;
  } else {
    data.name = name;
  }
  if (params) {
    data.params = params;
  }
  if (query) {
    data.query = query;
  }
  vm.$router.replace(data);
};


/**
 * 加载器实例
 */
Common.Preloader = {
  show() {
    Loading.service({lock: true, text: '加载中...', spinner: 'el-icon-loading'});
  },
  hidden() {
    Loading.service({lock: true, text: '加载中...', spinner: 'el-icon-loading'}).close();
  },
};

/**
 * 页面常用操作
 */
Common.PageOperator = {

  /**
   * 展现带输入框的提示信息
   * @param vm
   * @param title 标题
   * @param message 提示信息
   * @param inputValidator 输入校验器 校验未通过可返回Boolean或者String
   * @param submitFunc 确定回调
   * @param cancelFunc 取消回调
   */
  showPromptInput(vm, title, message, inputValidator, submitFunc, cancelFunc) {
    vm.$prompt(message, title, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputValidator,
      inputType: 'textarea',
    })
      .then(result => submitFunc(result.value))
      .catch(cancelFunc);
  },
  /**
   * 输入框提示信息扩展
   * inputValidator 输入框的校验函数
   * **/
  showPromptInputWithDefaultValue(vm, title, message, confirmButtonText, cancelButtonText, inputValue, inputValidator
    , submitFunc, cancelFunc) {
    vm.$prompt(message, title, {
      confirmButtonText,
      cancelButtonText,
      inputType: 'textarea',
      inputValue: inputValue ? inputValue : '',
      inputValidator,
    })
      .then(result => submitFunc(result.value))
      .catch(cancelFunc);
  },
  /**
   * 展现提示信息
   * @param vm
   * @param showClose
   * @param message
   * @param type  warning（警告）、error(错误)、info（友好提示）
   * @param duration 设置0则不会自动关闭
   */
  showPromptMsg(vm, showClose, message, type, duration) {
    const messageModel = {
      showClose,
      message,
      dangerouslyUseHTMLString: true,
      type,
    };
    if (duration == 0) {
      messageModel.duration = duration;
    }
    vm.$message(messageModel);
  },

  /**
   * 确认提示弹窗
   * @param vm
   * @param title
   * @param des
   * @param confirm 确认按钮
   * @param cancel 失败按钮
   * @param success 成功事件
   * @param fail 取消事件  可为 null
   */
  showConfirm(vm, title, des, confirm, cancel, success, fail) {
    const failFun = fail ? fail : function () {
    };
    vm.$confirm(des, title, {
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      type: 'warning'
    }).then(success)
      .catch(failFun);
  },
  /**
   * 消息提示
   * @param vm
   * @param title
   * @param desc
   * @param confirm 确认按钮
   * @param success 确认事件
   */
  showAlert(vm, title, desc, confirm, success) {
    vm.$alert(desc, title, {
      confirmButtonText: confirm ? confirm : '确定',
      callback: success
    });
  },
  /**
   * 展现HTML信息
   * @param vm
   * @param htmlDom
   */
  showPromptHtml(vm, htmlDom) {
    vm.$message({
      dangerouslyUseHTMLString: true,
      message: htmlDom,
    });
  },
  // 含有html片段的提示框
  showConfirmWithHtml(vm, title, html, confirm, cancel, success, fail) {
    const failFun = fail ? fail : function () {
    };
    vm.$confirm(html, title, {
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      type: 'warning',
      dangerouslyUseHTMLString: true,
    }).then(success)
      .catch(failFun);
  },


  /**
   * 检查错误提示， 并重置提交按钮
   * @param vm vue实例对象
   * @param resultData 响应结果
   * @param disableBtnName 按钮禁用vm名称
   * @returns {boolean}
   */
  checkResultData(vm, resultData, disableBtnName) {
    if (!resultData.success) {
      // 599表示错误消息已处理 5005表示用户未登录
      if (resultData.code != 599 && resultData.code != 5005) {
        let errorMsg = resultData.error;
        if (typeof (errorMsg) === 'object' && errorMsg[0].failedDesc && typeof (errorMsg[0].failedDesc) === 'object') {
          errorMsg = errorMsg[0].failedDesc[0];
        }
        this.showPromptMsg(vm, true, errorMsg, 'error');
      }
      if (disableBtnName != null && disableBtnName != undefined && vm.$data[disableBtnName]) {
        vm.$data[disableBtnName] = false;
      }
      return false;
    }
    return true;
  },

  /**
   * 显示通知消息
   * @param vm
   * @param isHtml
   * @param title
   * @param message
   */
  showNotifyMsg(vm, isHtml, title, message, time) {
    vm.$notify({
      title,
      message,
      dangerouslyUseHTMLString: isHtml,
      position: 'bottom-right',
      duration: time ? time : 5000,
    });
  },
};

// for the page data function
Common.PageDataUtil = {

  // 改变列表的的单个数据
  changeSimplePageData(data, index, changeModel) {
    return data.splice(index, 1, changeModel);
  },

  // append the paramName=paramValue into param url
  appendParamToUrl(paramUrl, connectStr, vm, paramParentName, paramName) {
    if (vm[paramParentName] && vm[paramParentName] != ''
      && vm[paramParentName][paramName] && vm[paramParentName][paramName] != null) {
      paramUrl = `${paramUrl + connectStr + paramName}=${encodeURIComponent(vm[paramParentName][paramName])}`;
    }
    return paramUrl;
  },

  // handle the page data into url to request
  pageDataHandleBefore(vm, url) {
    let pageDataUrl = '';
    if (!vm.$data.pageInfo) {
      vm.$data.pageInfo = {};
    }

    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'currentPage');
    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'pageSize');
    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'totalRows');
    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'orderBy');
    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'orderType');
    url = this.urlAppendParam(url, pageDataUrl);
    return url;
  },
  // 附加子公司信息
  childAgencyHandleBefore(vm, url) {
    let childAgencyUrl = '';
    // 子公司关键字 childAgencyId
    // 订单列表特殊判断
    if (url.indexOf('/crm/productSign/list') > -1) {
      if (vm.$parent && vm.$parent.$parent && vm.$parent.$parent.$refs && vm.$parent.$parent.$refs.collapse
        && vm.$parent.$parent.$refs.collapse.childAgencyId != '') {
        childAgencyUrl = `&childAgencyId=${encodeURIComponent(vm.$parent.$parent.$refs.collapse.childAgencyId)}`;
      }
    } else {
      if (vm.$refs.collapse && vm.$refs.collapse.childAgencyId && vm.$refs.collapse.childAgencyId != '') {
        childAgencyUrl = `&childAgencyId=${encodeURIComponent(vm.$refs.collapse.childAgencyId)}`;
      }
    }
    url = this.urlAppendParam(url, childAgencyUrl);
    return url;
  },

  // append the params at the end of URL
  urlAppendParam(url, appendParam) {
    if (appendParam != '') {
      appendParam = appendParam.substring(1, appendParam.length);
      if (url.indexOf('?') > 0) {
        url = `${url}&${appendParam}`;
      } else {
        url = `${url}?${appendParam}`;
      }
    }
    return url;
  },

  // handle the page data from response
  // eslint-disable-next-line no-unused-vars
  pageDataHandleAfter(vm, response, url) {
    const queryPageInfo = response.queryPage;
    const {pageInfo} = vm;
    if (pageInfo && queryPageInfo) {
      // eslint-disable-next-line no-unused-vars
      for (const paramKey in queryPageInfo) {
        vm.$set(vm.pageInfo, 'currentPage', queryPageInfo.currentPage);
        vm.$set(vm.pageInfo, 'pageSize', queryPageInfo.pageSize);
        vm.$set(vm.pageInfo, 'totalRows', queryPageInfo.totalRows);
        vm.$set(vm.pageInfo, 'orderBy', queryPageInfo.orderBy);
        vm.$set(vm.pageInfo, 'orderType', queryPageInfo.orderType);
      }
    }
  },

  /**
   * 重置分页并重新请求
   * @param vm
   */
  resetPageInfo(vm) {
    if (vm.pageInfo) {
      vm.$set(vm.pageInfo, 'currentPage', 1);
      vm.$set(vm.pageInfo, 'totalRows', -1);
    }
  },
  /**
   * 分页排序方法
   * @param vm
   * @param column  行对象，其中 column.order 排序(descending,ascending) ; column.prop 排序属性
   * @param prop
   * @param order
   * **/
  // eslint-disable-next-line no-unused-vars
  sortChangeFun(vm, column, prop, order) {
    vm.pageInfo.orderBy = column.prop;
    let orderType;
    if (column.order) {
      const index = column.order.indexOf('ending');
      orderType = column.order.slice(0, index);
    }
    vm.pageInfo.orderType = orderType;
    vm.pageInfo.getListFun();
  },
};

/**
 * 请求操作实例
 */
Common.Request = {

  /**
   * 发送请求前，对URL的处理
   * @param vm vue实例对象
   * @param url 请求地址
   * @param urlData url参数
   * @returns {*}
   */
  beforeSend(vm, url, urlData) {
    if (!urlData) {
      urlData = {};
    }
    if (url.indexOf('http://') != 0 && url.indexOf('https://') != 0) {
      // if (url.substring(0, 1) != '/') {
      //     url = "/" + url;
      // }
      if (url.substring(url.length - url) == '/') {
        url = url.substring(url.length - 1);
      }
    }
    url = Common.URL.appendURLData(url, vm, urlData);
    return url;
  },

  /**
   * 添加部门过滤选项
   * @param vm 将会检查vm中绑定的deptFilter对象(该对象为需要过滤的部门实体)
   * @param url
   * @return {*}
   */
  appendDeptFilter(vm, url) {
    const deptFilter = Common.URL.filterValue(vm.deptFilter);
    if (!deptFilter) {
      return url;
    }

    const urlDeptFilter = {};
    const deptCodes = ['agencyId', 'depCode', 'subDepCode', 'teamCode', 'teamCode2', 'teamCode3', 'teamCode4', 'teamCode5'];
    for (const pos in deptCodes) {
      const filterValue = Common.URL.filterValue(deptFilter[deptCodes[pos]]);
      if (!filterValue) {
        break;
      }
      urlDeptFilter[`${deptCodes[pos]}Select`] = filterValue;
    }
    url = Common.URL.appendURLData(url, vm, urlDeptFilter);
    return url;
  },

  /**
   * 接收请求后，对response的处理
   * @param vm vue实例对象
   * @param response 响应结果
   * @param url 请求地址
   * @param postData post内容对象
   * @returns {*}
   */
  afterResponse(vm, response, url) {
    var result = response;
    // 服务器代码内部运行错误、数据校验失败
    if (response != null && response.code == 3000) {
      var validatorMsgMap = response.error;
      if (!validatorMsgMap) {
        return result;
      }
      Common.PageOperator.showPromptMsg(vm, true, validatorMsgMap, 'error');
      return "abort";
    }
    //渠道活动报名
    if(url.indexOf('activity/shareSignup')>-1 && response && response.code== 81){
      return {
        activitySignId:response.error,
        isSigned:'Y'
      }
    }
    // 包含错误信息
    if (!response.success) {
      if (typeof response.error === 'string') {
        Common.PageOperator.showPromptMsg(vm, true, response.error, 'warning');
      }
      return 'abort';
    }
    if (result != null && result.success && Common.Util.isString(result.data) && /[\u0391-\uFFE5]+/.test(result.data)) {
      Common.PageOperator.showPromptMsg(vm, true, result.data, 'success');
      return result.data;
    }
    // 返回字段包含 signle 时
    if (response != null && response.success && typeof (response.signle) != 'undefined') {
      var dataListLength = Common.Util.getJsonObjectLength(response.dataList);
      if (response.signle) {
        if (dataListLength == 0) {
          response.data = null;
        } else {
          response.data = response.dataList[0];
        }
      } else {
        response.data = response.dataList;
      }
      return response.data;
    }
    return result.data;
  },

  getResponseError(response) {
    let errorMsg = (response == null ? '无法连接服务器' : response);
    if (response != null) {
      errorMsg = response.message;
    }
    return errorMsg;
  },
};

/**
 * 常用处理类
 */
Common.Util = {

  /**
   * 克隆对象
   * @param obj
   * @returns {*}
   */
  clone(obj) {
    if (typeof (obj) !== 'object') {
      return obj;
    }

    let re = {};
    if (obj.constructor == Array) {
      re = [];
    }

    for (const i in obj) {
      if (obj[i] == null) {
        re[i] = null;
      } else {
        re[i] = this.clone(obj[i]);
      }
    }
    return re;
  },

  /**
   * 生成UUID值
   * @returns {string}
   */
  generateId() {
    const s4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4()).toLowerCase();
  },

  /**
   * 判断是否为空对象
   * @param obj 需要判断的对象
   * @returns {boolean}
   */
  isEmpty(obj) {
    if (obj == '' || obj == null || obj == 'null'
      || typeof (obj) === undefined || obj == 'undefined') {
      return true;
    }
    return false;
  },
  /**
   * 判断是否为数组
   * @param obj
   * @returns {boolean}
   */
  isArray(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  },

  /**
   * 判断是否是字符串
   * @param obj
   * @returns {boolean}
   */
  isString(obj) {
    return typeof obj === 'string';
  },
  /**
   * 判断是否未定义
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is undefined.
   */
  isUndefined(value) {
    return typeof value === 'undefined';
  },
  /**
   * 获取对象长度
   * @param data
   * @returns {number}
   */
  getJsonObjectLength(data) {
    if (!data) {
      return -1;
    }

    var length = 0;
    for (var key in data) {
      length++;
    }
    return length;
  },


  /**
   * 判断是否已定义
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is defined.
   */
  isDefined(value) {
    return typeof value !== 'undefined';
  },


  /**
   * 判断是否为对象
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is an `Object` but not `null`.
   */
  isObject(value) {
    return value !== null && typeof value === 'object';
  },

  /**
   * 判断是否为数字
   * 包含特殊数字 `NaN`, `+Infinity` 和 `-Infinity`.
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Number`.
   */
  isNumber(value) {
    return typeof value === 'number';
  },

  /**
   * 判断是否为日期类型
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Date`.
   */
  isDate(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
  },

  /**
   * 判断对象是否为方法
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Function`.
   */
  isFunction(value) {
    return typeof value === 'function';
  },

  /**
   * 判断是否为正则表达式
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `RegExp`.
   */
  isRegExp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
  },
  /**
   * 判断是否为手机号码
   * @param value
   * @returns {boolean}
   */
  isMobile(value) {
    // 大陆
    // ^((\\+86\\-)?)1(3|5|7|8)\\d{9}$
    const mobileMainland = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
    // 香港
    // ^(\\+852\\-)(5|6|9)\\d{7}$
    const mobileHongKong = /^((\+852-)(5|6|9)+\d{7})$/;
    // 澳门
    // ^(\\+853\\-)(6|8)\\d{7})$
    const mobileAomen = /^((\+853-)(6|8)+\d{7})$/;
    // 台湾
    // ^(\\+886\\-)09\\d{8}$
    const mobileTaiwan = /^((\+886-)(09)+\d{8})$/;
    return mobileMainland.test(value) || mobileHongKong.test(value) || mobileAomen.test(value)
      || mobileTaiwan.test(value);
  },
  /* 带区号的手机号码验证*/
  isMobileCode: function (str,mobile) {
  const mobileCode = /^1[3-9]\d{9}$/
  const mobileCodeTo = /^\d{1,15}$/
  if(str == '86'){
      return mobileCode.test(mobile) 
  }else{
      return mobileCodeTo.test(mobile) 
  }
  },
  /**
   * 判断是否是微信浏览器
   * @returns {boolean}
   */
  isWeiXin: function () {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 判断是否为中文
   * @param s
   * @returns {boolean}
   */
  IsChar(s) {
    const Number = '0123456789.abcdefghijklmnopqrstuvwxyz-/ABCDEFGHIJKLMNOPQRSTUVWXYZ`~!@#$%^&*()_';
    for (let i = 0; i < s.length; i++) {
      const c = s.charAt(i);
      if (Number.indexOf(c) == -1) {
        return true;
      }
    }
    return false;
  },
  /**
   * 判断是数字、英文字母，逗号
   * @param s
   * @returns {boolean}
   */
  isNumEng(value) {
    const str = /^[a-z0-9\\,]+$/i;
    return str.test(value);
  },
  /**
   * 取得boolean类型值
   * @param value 需要判断的值
   * @param defaultValue 默认值
   * @returns {*}
   */
  getBooleanValue(value, defaultValue) {
    if (value == 'false' || value == false) {
      return false;
    }
    if (value == 'true' || value == true) {
      return true;
    }
    return defaultValue;
  },

  /**
   * 取得String类型值
   * @param value 需要判断的值
   * @param defaultValue 默认值
   * @returns {*}
   */
  getStringValue(value, defaultValue) {
    if (value) {
      return value;
    }
    return defaultValue;
  },

  /**
   * 取得Integer类型值
   * @param value 需要判断的值
   * @param defaultValue 默认值
   * @returns {*}
   */
  getIntValue(value, defaultValue) {
    if (value && this.Util.isNumber(value)) {
      return value;
    }
    return defaultValue;
  },

  /**
   * 判断是否为价格
   * @param value
   * @returns {boolean}
   */
  isPrice(vm, value) {
    if (Common.Util.isEmpty(value)) {
      return false;
    }
    if (!/^[+]?(\d{1,8})(\.\d{0,2})?$/.test(value)) {
      Common.PageOperator.showPromptMsg(vm, true, '价格只能包含数字、小数两位的字符', 'warning');
      return false;
    }
    return true;
  },

  /**
   * 判断整数value是否大于0
   * @param vm
   * @param value
   * @returns {boolean}
   */
  isIntGtZero(vm, value) {
    if (Common.Util.isEmpty(value)) {
      return false;
    }
    const isNumber = /^[-+]?\d+$/.test(value);
    value = parseInt(value);
    if (!isNumber || value < 0) {
      Common.PageOperator.showPromptMsg(vm, true, '请填写大于0的整数', 'warning');
      return false;
    }
    return true;
  },
};

/**
 * URL参数实例
 */
Common.URL = {

  /**
   * 添加vm中的数据值
   * @param url 已存在的URL地址
   * @param vm vue实例对象
   * @param urlData 添加的URL参数
   * @returns {*}
   */
  appendURLData(url, vm, urlData) {
    if (!urlData) {
      return url;
    }
    for (const key in urlData) {
      const value = this.filterValue(urlData[key]);
      if (typeof (value) !== 'undefined' && value != null) {
        url = this.appendURL(url, key, value);
      }
    }
    return url;
  },

  /**
   * 添加vm中的数据值
   * @param url 已存在的URL地址
   * @param vm vue实例对象
   * @param key vue实例对象key名称
   * @returns {*}
   */
  appendVmData(url, vm, key) {
    const value = this.getVmValue(key);
    if (value) {
      url = this.appendURL(url, key, value);
    }
    return url;
  },

  getUrlParm(name) {
    const regexS = `[\\?&]${name}=([^&#]*)`;
    const regex = new RegExp(regexS);
    const tmpURL = document.location.href;
    const results = regex.exec(tmpURL);
    if (results == null) {
      return '';
    }
    return results[1];
  },

  /**
   * 取得服务器地址
   * @returns {string}
   */
  getServerUrl() {
    let serverUrl = document.location.href;
    const firstPos = serverUrl.indexOf('/', 8);
    const secondPos = serverUrl.indexOf('/', firstPos + 1);
    serverUrl = serverUrl.substring(0, secondPos);
    return serverUrl;
  },

  /**
   * 取得域名
   * @returns {string}
   */
  getServerDomain() {
    const serverUrl = this.getServerUrl();
    let domain = serverUrl.substring('http://'.length, serverUrl.length);
    if (domain.indexOf('/') > 0) {
      domain = domain.substring(0, domain.indexOf('/'));
    }
    return domain;
  },

  /**
   * 过滤value值，如果是空，null,undefined等，自动转换为空字符''
   * @param value 需要过滤的值
   * @returns {*}
   */
  filterValue(value) {
    if (value == null || value == 'null' || value == undefined || value == 'undefined') {
      return '';
    }
    return value;
  },

  /**
   * 取得vue实例中data中的值
   */
  getVmValue(vm, key) {
    const value = vm.$data[key];
    vm.$data[key] = this.filterValue(value);
    return vm.$data[key];
  },

  /**
   * 追加URL参数
   * @param url 已存在的URL数据
   * @param key 追加参数的key名称
   * @param value 追加的值, 可以是数组，基本类型，JSON对象等
   * @returns {*}
   */
  appendURL(url, key, value) {
    if (typeof (value) === 'undefined' || value == null) {
      value = '';
    }

    let values = [];
    if (Common.Util.isArray(value)) {
      values = value;
    } else {
      values.push(value);
    }

    for (const pos in values) {
      const urlKey = key;
      const urlValue = values[pos];

      const isJSONObj = typeof (urlValue) === 'object' && Object.prototype.toString.call(urlValue).toLowerCase() == '[object object]' && !urlValue.length;
      if (isJSONObj) {
        for (const jsonKey in urlValue) {
          this.appendEncodeURL(url, jsonKey, urlValue[jsonKey]);
        }
        return url;
      }

      return this.appendEncodeURL(url, urlKey, urlValue);
    }
    return url;
  },

  /**
   * 追加URL参数键值
   * @param url 已存在的URL参数
   * @param urlKey 追加URL参数名
   * @param urlValue 追加URL参数值
   * @returns {*}
   */
  appendEncodeURL(url, urlKey, urlValue) {
    if (url.indexOf('?') > 0) {
      url = `${url}&${urlKey}=${encodeURIComponent(urlValue)}`;
    } else {
      url = `${url}?${urlKey}=${encodeURIComponent(urlValue)}`;
    }
    return url;
  },
};

Common.Permission = {
  /**
   * 校验当前人是否具有指定部门的操作权限
   * @param vm
   * @param deptModel 部门实体
   * @returns {boolean}
   */
  checkDeptPermit(vm, deptModel) {
    const {dataPermits} = vm.$store.state.user;
    if (!deptModel || dataPermits.length == 0) {
      return false;
    }

    const codeIdFields = ['agencyId', 'depCode', 'subDepCode', 'teamCode', 'teamCode2', 'teamCode3', 'teamCode4', 'teamCode5'];
    let permitId = '';
    for (const pos in codeIdFields) {
      const codeId = deptModel[codeIdFields[pos]];
      if (!codeId) {
        break;
      }
      permitId = `${permitId + codeId}@@`;
    }
    if (!permitId) {
      return false;
    }
    for (const pos in dataPermits) {
      if (permitId.indexOf(dataPermits[pos]) == 0) {
        return true;
      }
    }
    return false;
  },

  /**
   * 检查当前人是否具有指定按钮的操作权限
   * @param btnId 按钮标示
   * @returns {boolean}
   */
  checkBtnPermit(store, btnId) {
    if (!store.state.user || !store.state.user.operPermits) {
      return false;
    }

    const buttonPermitMap = store.state.user.operPermits.button;
    if (buttonPermitMap && buttonPermitMap[btnId] >= 1) {
      return true;
    }
    return false;
  },

  /**
   * 取得当前人获取的appId和appSecret
   */
  getAppIdSecret() {
    if (this.appId && this.appSecret) {
      return [this.appId, this.appSecret];
    }
    const appId = Common.CookieOperator.getCookie('liveMobileAppId');
    const appSecret = Common.CookieOperator.getCookie('liveMobileAppSecret');
    if (appId && appSecret) {
      this.appId = appId;
      this.appSecret = appSecret;
      return [this.appId, this.appSecret];
    }
    return [null, null];
  },

  /**
   * 判断参数名是否合法
   * @param method 请求方法名
   * @param urlParams 请求URL参数集合
   * @returns {*}
   */
  filterReqParamKey(method, urlParams) {
    const deleteKeys = [];
    if (urlParams == null || typeof (urlParams) === 'undefined') {
      urlParams = {};
    }
    if (urlParams) {
      for (const paramKey in urlParams) {
        const paramValue = urlParams[paramKey];
        if (paramValue == null || typeof (paramValue) === 'undefined') {
          deleteKeys.push(paramKey);
          continue;
        }
        if (paramKey == 'appid' || paramKey == 'method' || paramKey == 'timestamp' || paramKey == 'sign') {
          alert(`请求方法${method}包含${paramKey}非法关键参数名，请联系管理员！`);
          return null;
        }
      }
      if (deleteKeys.length > 0) {
        for (const pos in deleteKeys) {
          const deleteKey = deleteKeys[pos];
          delete urlParams[deleteKey];
        }
      }
    }
    return urlParams;
  },
};

/**
 * Cookie常用实例
 */
Common.CookieOperator = {

  /**
   * 设置cookie值
   * @param name 名称
   * @param value 值
   * @param expires 过期时间， 默认30天
   * @param path 路径，默认当前路径
   * @param domain 域名，
   */
  setCookie(name, value, expires, path, domain) {
    const uexp = new Date().getTime() + (1000 * 60 * 60 * 24 * 30);
    const expdate = new Date();
    expdate.setTime(uexp);

    path = path ? path : '/';
    domain = domain ? domain : Common.URL.getServerDomain();
    expires = expires ? expires : expdate.toGMTString();

    document.cookie = `${name}=${escape(value)
      };expires=${expires}`
      + `; path=${path}`
      + `; domain=${domain}`;
  },

  delCookie(name) {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);
    this.setCookie(name, '', exp);
  },

  getCookie(fname) {
    let name;
    let value;
    let beginning;
    let middle;
    let end;

    beginning = 0;
    while (beginning < document.cookie.length) {
      middle = document.cookie.indexOf('=', beginning);
      end = document.cookie.indexOf(';', beginning);

      if (end == -1) {
        end = document.cookie.length;
      }
      if ((middle > end) || (middle == -1)) {
        name = document.cookie.substring(beginning, end);
        value = '';
      } else {
        name = document.cookie.substring(beginning, middle);
        value = document.cookie.substring(middle + 1, end);
      }
      if (name == fname) {
        return unescape(value);
      }

      beginning = end + 2;
    }
  },
};


/**
 * 时间处理常用操作
 */
Common.Date = {
  /**
   * 取得当前时间字符串，格式为yyyy-MM-dd
   * @returns {string}
   */
  getCurrentDateStr(time) {
    let date = '';
    if (time) {
      date = new Date(time);
    } else {
      date = new Date();
    }
    const year = date.getFullYear();
    let month = (date.getMonth() + 1);
    if (parseInt(month) < 10) {
      month = `0${date.getMonth() + 1}`;
    }
    let day = date.getDate();
    if (parseInt(day) < 10) {
      day = `0${date.getDate()}`;
    }
    const currentDate = `${year}-${month}-${day}`;
    return currentDate;
  },
  /** *
   * 获得当前时间
   */
  getCurrentDate() {
    const currentDate = new Date();
    return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
  },

  /** *
   * 获得指定日期的起始日期
   */
  getStartDate(date) {
    const startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    return startDate;
  },

  /** *
   * 获得指定日期的结束日期
   */
  getEndDate(date) {
    const endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
    return endDate;
  },

  /** *
   * 获得指定日期当天的起止日期
   */
  getStartEndDates(date) {
    const startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    const endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
    return [startDate, endDate];
  },

  /** *
   * 获得当前日期的起止日期
   */
  getCurrentDates() {
    const currentDate = this.getCurrentDate();
    return this.getStartEndDates(currentDate);
  },

  /**
   * 取得昨天日期的起止日期
   */
  getYesterdayDates() {
    const currentDate = this.getCurrentDate();
    currentDate.setDate(currentDate.getDate() - 1);
    return this.getStartEndDates(currentDate);
  },

  /** *
   * 获得本周起止时间
   */
  getCurrentWeek() {
    // 起止日期数组
    const startStop = [];
    // 获取当前时间
    const currentDate = this.getCurrentDate();
    // 返回date是一周中的某一天
    const week = currentDate.getDay();
    // 返回date是一个月中的某一天
    // eslint-disable-next-line no-unused-vars
    const month = currentDate.getDate();

    // 一天的毫秒数
    const millisecond = 1000 * 60 * 60 * 24;
    // 减去的天数
    const minusDay = week != 0 ? week - 1 : 6;
    // alert(minusDay);
    // 本周 周一
    const monday = new Date(currentDate.getTime() - (minusDay * millisecond));
    // 本周 周日
    const sunday = new Date(monday.getTime() + (6 * millisecond));
    // 添加本周时间
    startStop.push(this.getStartDate(monday)); // 本周起始时间
    // 添加本周最后一天时间
    startStop.push(this.getEndDate(sunday)); // 本周终止时间
    // 返回
    return startStop;
  },

  /** *
   * 获得本月的起止时间
   */
  getCurrentMonth() {
    // 起止日期数组
    const startStop = [];
    // 获取当前时间
    const currentDate = this.getCurrentDate();
    // 获得当前月份0-11
    let currentMonth = currentDate.getMonth();
    // 获得当前年份4位年
    let currentYear = currentDate.getFullYear();
    // 求出本月第一天
    const firstDay = new Date(currentYear, currentMonth, 1);


    // 当为12月的时候年份需要加1
    // 月份需要更新为0 也就是下一年的第一个月
    if (currentMonth == 11) {
      currentYear += 1;
      currentMonth = 0; // 就为
    } else {
      // 否则只是月份增加,以便求的下一月的第一天
      currentMonth += 1;
    }


    // 一天的毫秒数
    const millisecond = 1000 * 60 * 60 * 24;
    // 下月的第一天
    const nextMonthDayOne = new Date(currentYear, currentMonth, 1);
    // 求出上月的最后一天
    const lastDay = new Date(nextMonthDayOne.getTime() - millisecond);

    // 添加至数组中返回
    startStop.push(this.getStartDate(firstDay));
    startStop.push(this.getEndDate(lastDay));
    // 返回
    return startStop;
  },
  /**
   * 得到指定月份的起止时间
   * @param dateStr
   * @returns {*[]}
   */
  getAppointMonthStartEndDate(dateStr) {
    const newDate = this.convertStrToDate(dateStr);
    const monthDays = this.getMonthDays(newDate.getFullYear(), newDate.getMonth());

    // 获得此月开始时间
    const monthStartDate = new Date(newDate.getFullYear(), newDate.getMonth());
    const monthEndDate = new Date(newDate.getFullYear(), newDate.getMonth(), monthDays);
    return [monthStartDate, monthEndDate];
  },
  /**
   * 得到本季度开始的月份
   * @param month 需要计算的月份
   ***/
  getQuarterSeasonStartMonth(month) {
    // eslint-disable-next-line no-unused-vars
    const quarterMonthStart = 0;
    const spring = 0; // 春
    const summer = 3; // 夏
    const fall = 6;   // 秋
    const winter = 9; // 冬
    // 月份从0-11
    if (month < 3) {
      return spring;
    }

    if (month < 6) {
      return summer;
    }

    if (month < 9) {
      return fall;
    }

    return winter;
  },

  /**
   * 获得该月的天数
   * @param year 年份
   * @param month 月份
   * */
  getMonthDays(year, month) {
    // 本月第一天 1-31
    const relativeDate = new Date(year, month, 1);
    // 获得当前月份0-11
    let relativeMonth = relativeDate.getMonth();
    // 获得当前年份4位年
    let relativeYear = relativeDate.getFullYear();

    // 当为12月的时候年份需要加1
    // 月份需要更新为0 也就是下一年的第一个月
    if (relativeMonth == 11) {
      relativeYear += 1;
      relativeMonth = 0;
    } else {
      // 否则只是月份增加,以便求的下一月的第一天
      relativeMonth += 1;
    }
    // 一天的毫秒数
    const millisecond = 1000 * 60 * 60 * 24;
    // 下月的第一天
    const nextMonthDayOne = new Date(relativeYear, relativeMonth, 1);
    // 返回得到上月的最后一天,也就是本月总天数
    return new Date(nextMonthDayOne.getTime() - millisecond).getDate();
  },

  /**
   * 获得本季度的起止日期
   */
  getCurrentSeason() {
    // 起止日期数组
    const startStop = [];
    // 获取当前时间
    const currentDate = this.getCurrentDate();
    // 获得当前月份0-11
    const currentMonth = currentDate.getMonth();
    // 获得当前年份4位年
    const currentYear = currentDate.getFullYear();
    // 获得本季度开始月份
    const quarterSeasonStartMonth = this.getQuarterSeasonStartMonth(currentMonth);
    // 获得本季度结束月份
    const quarterSeasonEndMonth = quarterSeasonStartMonth + 2;

    // 获得本季度开始的日期
    const quarterSeasonStartDate = new Date(currentYear, quarterSeasonStartMonth, 1);
    // 获得本季度结束的日期
    const quarterSeasonEndDate = new Date(currentYear, quarterSeasonEndMonth
      , this.getMonthDays(currentYear, quarterSeasonEndMonth));
    // 加入数组返回
    startStop.push(this.getStartDate(quarterSeasonStartDate));
    startStop.push(this.getEndDate(quarterSeasonEndDate));
    // 返回
    return startStop;
  },

  /** *
   * 得到本年的起止日期
   *
   */
  getCurrentYear() {
    // 起止日期数组
    const startStop = [];
    // 获取当前时间
    const currentDate = this.getCurrentDate();
    // 获得当前年份4位年
    const currentYear = currentDate.getFullYear();

    // 本年第一天
    const currentYearFirstDate = new Date(currentYear, 0, 1);
    // 本年最后一天
    const currentYearLastDate = new Date(currentYear, 11, 31);
    // 添加至数组
    startStop.push(this.getStartDate(currentYearFirstDate));
    startStop.push(this.getEndDate(currentYearLastDate));
    // 返回
    return startStop;
  },

  /**
   * 返回上一个月的第一天Date类型
   * @param year 年
   * @param month 月
   **/
  getPriorMonthFirstDay(year, month) {
    // 年份为0代表,是本年的第一月,所以不能减
    if (month == 0) {
      month = 11; // 月份为上年的最后月份
      year -= 1; // 年份减1
      return new Date(year, month, 1);
    }
    // 否则,只减去月份
    month -= 1;
    return new Date(year, month, 1);
  },

  /**
   * 获得上一月的起止日期
   * ***/
  getPreviousMonth() {
    // 起止日期数组
    const startStop = [];
    // 获取当前时间
    const currentDate = this.getCurrentDate();
    // 获得当前月份0-11
    const currentMonth = currentDate.getMonth();
    // 获得当前年份4位年
    const currentYear = currentDate.getFullYear();
    // 获得上一个月的第一天
    const priorMonthFirstDay = this.getPriorMonthFirstDay(currentYear, currentMonth);
    // 获得上一月的最后一天
    const priorMonthLastDay = new Date(priorMonthFirstDay.getFullYear(), priorMonthFirstDay.getMonth()
      , this.getMonthDays(priorMonthFirstDay.getFullYear(), priorMonthFirstDay.getMonth()));
    // 添加至数组
    startStop.push(this.getStartDate(priorMonthFirstDay));
    startStop.push(this.getEndDate(priorMonthLastDay));
    // 返回
    return startStop;
  },


  /**
   * 获得上一周的起止日期
   * **/
  getPreviousWeek() {
    // 起止日期数组
    const startStop = [];
    // 获取当前时间
    const currentDate = this.getCurrentDate();
    // 返回date是一周中的某一天
    const week = currentDate.getDay();
    // 返回date是一个月中的某一天
    // eslint-disable-next-line no-unused-vars
    const month = currentDate.getDate();
    // 一天的毫秒数
    const millisecond = 1000 * 60 * 60 * 24;
    // 减去的天数
    const minusDay = week != 0 ? week - 1 : 6;
    // 获得当前周的第一天
    const currentWeekDayOne = new Date(currentDate.getTime() - (millisecond * minusDay));
    // 上周最后一天即本周开始的前一天
    const priorWeekLastDay = new Date(currentWeekDayOne.getTime() - millisecond);
    // 上周的第一天
    const priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (millisecond * 6));

    // 添加至数组
    startStop.push(this.getStartDate(priorWeekFirstDay));
    startStop.push(this.getEndDate(priorWeekLastDay));

    return startStop;
  },
  /**
   * 得到上季度的起始日期
   * year 这个年应该是运算后得到的当前本季度的年份
   * month 这个应该是运算后得到的当前季度的开始月份
   * */
  getPriorSeasonFirstDay(year, month) {
    const spring = 0; // 春
    const summer = 3; // 夏
    const fall = 6;   // 秋
    const winter = 9; // 冬

    // 月份从0-11
    if (month >= spring && month < summer) {
      year -= 1;
      month = winter;
    } else if (month >= summer && month < fall) {
      month = spring;
    } else if (month >= fall && month < winter) {
      month = summer;
    } else if (month >= winter) {
      month = fall;
    }
    return new Date(year, month, 1);
  },

  /**
   * 得到上季度的起止日期
   * **/
  getPreviousSeason() {
    // 起止日期数组
    const startStop = [];
    // 获取当前时间
    const currentDate = this.getCurrentDate();
    // 获得当前月份0-11
    const currentMonth = currentDate.getMonth();
    // 获得当前年份4位年
    const currentYear = currentDate.getFullYear();
    // 上季度的第一天
    const priorSeasonFirstDay = this.getPriorSeasonFirstDay(currentYear, currentMonth);
    // 上季度的最后一天
    const priorSeasonLastDay = new Date(priorSeasonFirstDay.getFullYear(), priorSeasonFirstDay.getMonth() + 2
      , this.getMonthDays(priorSeasonFirstDay.getFullYear(), priorSeasonFirstDay.getMonth() + 2));
    // 添加至数组
    startStop.push(this.getStartDate(priorSeasonFirstDay));
    startStop.push(this.getEndDate(priorSeasonLastDay));
    return startStop;
  },
  /**
   * 得到去年的起止日期
   * **/
  getPreviousYear() {
    // 起止日期数组
    const startStop = [];
    // 获取当前时间
    const currentDate = this.getCurrentDate();
    // 获得当前年份4位年
    let currentYear = currentDate.getFullYear();
    currentYear -= 1;
    const priorYearFirstDay = new Date(currentYear, 0, 1);
    const priorYearLastDay = new Date(currentYear, 11, 1);
    // 添加至数组
    startStop.push(this.getStartDate(priorYearFirstDay));
    startStop.push(this.getEndDate(priorYearLastDay));
    return startStop;
  },

  /**
   * 取得当前时间字符串形式 yyyy-MM-dd hh:mm:ss
   * @returns {string}
   */
  getDateFormat(date) {
    const seperator1 = '-';
    const seperator2 = ':';
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = `0${month}`;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = `0${strDate}`;
    }
    let getHours = date.getHours();
    if (getHours >= 0 && getHours <= 9) {
      getHours = `0${getHours}`;
    }
    const currentdate = `${date.getFullYear() + seperator1 + month + seperator1 + strDate
    } ${Common.Date.toTwoUitl(date.getHours())}${seperator2}${Common.Date.toTwoUitl(date.getMinutes())
    }${seperator2}${Common.Date.toTwoUitl(date.getSeconds())}`;
    return currentdate;
  },
  /**
   *大于等于0或小于等于9转换为0+
   */
  toTwoUitl(str) {
    if (str >= 0 && str <= 9) {
      str = `0${str}`;
    }
    return str;
  },
  getDateFormatNoTime(date) {
    const seperator1 = '-';
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = `0${month}`;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = `0${strDate}`;
    }
    const currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },

  /**
   *  将字符串时间yyyy-MM-dd hh:mm:ss转换为时间对象
   * @param dataStr
   * @returns {Date}
   */
  convertStrToDate(dataStr) {
    const dt = new Date(dataStr.replace(/-/g, "/"));
    return dt;
  },
  /**
   *  将字符串时间hh:mm:ssyyy-MM-dd 转换为时间对象
   * @param dataStr
   * @returns {Date}
   */
  newsDateStr(date) {
    const seperator2 = ':';
    const currentdate = Common.Date.toTwoUitl(date.getHours()) + seperator2 + Common.Date.toTwoUitl(date.getMinutes())
      + seperator2 + Common.Date.toTwoUitl(date.getSeconds());
    return currentdate;
  },
  /**
   * 比较两个时间对象大小
   * @param date1
   * @param date2
   * @returns {number}
   */
  compareDate(date1, date2) {
    date1 = Date.parse(date1);
    date2 = Date.parse(date2);
    // date1=date1.getTime()
    // date2=date2.getTime()
    if (date1 > date2) {
      return 1;
    }
    if (date1 == date2) {
      return 0;
    }
    if (date1 < date2) {
      return -1;
    }
  },
  /**
   * 默认时间转换成起止 yyyy-MM-dd hh:mm:ss
   * 使用Common.Date.currentDateToYMD("本月")
   *换成：2019-01-01 00:00:00 2019-01-31 23:59:59
   */
  currentDateToYMD(dateName) {
    let date;
    switch (dateName) {
      case '昨天':
        date = Common.Date.getYesterdayDates();
        break;
      case '今天':
        date = Common.Date.getCurrentDates();
        break;
      case '本周':
        date = Common.Date.getCurrentWeek();
        break;
      case '上周':
        date = Common.Date.getPreviousWeek();
        break;
      case '本月':
        date = Common.Date.getCurrentMonth();
        break;
      case '上月':
        date = Common.Date.getPreviousMonth();
        break;
      case '本季度':
        date = Common.Date.getCurrentSeason();
        break;
      case '上季度':
        date = Common.Date.getPreviousSeason();
        break;
      case '本年':
        date = Common.Date.getCurrentYear();
        break;
      case '去年':
        date = Common.Date.getPreviousYear();
        break;
    }
    const dates = [];
    for (const i in date) {
      dates.push(Common.Date.getDateFormat(date[i]));
    }
    return dates;
  },

  /**
   * 判断时间
   * startDate 开始时间
   * endDate 结束时间
   *isStartDate为true时要先选择开始时间
   */
  dateContrast(vm, startDate, endDate, isStartDate) {
    const systemTime = new Date();
    if (startDate == '' && isStartDate == true) {
      Common.PageOperator.showPromptMsg(vm, true, '请先选择开始时间', 'warning');
      return false;
    }
    // eslint-disable-next-line no-unused-vars
    const timeCompareResult = Common.Date.compareDate(Common.Date.convertStrToDate(startDate), systemTime);
    // if(timeCompareResult<0){
    //  Common.PageOperator.showPromptMsg(vm, true,'项目开始时间不能小于当前时间','warning');
    //  return false;
    // }
    const endOrStartResult = Common.Date.compareDate(Common.Date.convertStrToDate(endDate)
      , Common.Date.convertStrToDate(startDate));
    if (endOrStartResult < 0) {
      Common.PageOperator.showPromptMsg(vm, true, '结束时间不能小于开始时间', 'warning');
      return false;
    }
  },

  /**
   * 获取财年的下拉框列表
   * @returns {Array}
   */
  fiscalYearArr() {
    // 获取当前实际
    const currentYear = new Date().getFullYear();
    const fiscalYearArr = [];
    for (let i = 2018; i <= currentYear + 1; i++) {
      fiscalYearArr.push(i);
    }
    return fiscalYearArr;
  },
  /**
   * 返回天、时、分
   */
  timeFun(val) {
    let t = '';
    if (val) {
      if (val < 60) {
        t = `${val}秒`;
      } else {
        // 计算出相差天数
        const days = Math.floor(val / (24 * 60 * 60));
        const hours = Math.floor((val - days * 24 * 60 * 60) / (60 * 60));
        const minute = (Math.floor(val - (24 * days + hours) * 60 * 60) / 60).toFixed(0);
        if (days) {
          t = `${days}天`;
        }
        if (hours) {
          t = `${t + hours}小时`;
        }
        if (minute) {
          t = `${t + minute}分`;
        }
      }
    }
    return t;
  },
  /**
   * 返回16位时间字符串
   */
  time16(val) {
    let t = '';
    if (val) {
      t = val.slice(0, 16);
    }
    return t;
  },
  /**
   * 返回16位时间字符串
   */
  time10(val) {
    let t = '';
    if (val) {
      t = val.slice(0, 10);
    }
    return t;
  },
  /**
   * 返回16位时间字符串
   */
  timeAfter5(val) {
    let t = '';
    if (val) {
      t = val.slice(11, 16);
    }
    return t;
  },
};
Common.data = {
  name24(val) {
    let name = '';
    if (val) {
      if (val.length > 24) {
        name = `${val.slice(0, 24)}...`;
      } else {
        name = val;
      }
    }
    return name;
  },
};
Common.format = {
  /**
   * 表头是万的，转换成万为单位，而且小于1万时保留小数点后4位，大于1万时保留小数点后2位
   * **/
  formatMoneyMyriad(money) {
    if (money == 0) {
      return 0;
    }
    if (money >= 10000) {
      return (money / 10000).toFixed(2);
    }
    return (money / 10000).toFixed(4);
  },
  /**
   * 表头是没有万的，转换成万为单位，而且小于1万时返回原数，大于1万时保留小数点后2位
   * **/
  formatMoney(money) {
    if (money >= 10000) {
      return `${(money / 10000).toFixed(2)}万`;
    }
    return money;
  },
};
// Common.downFile = {
//   downVideo(vm, url, name) {
//     if (url.indexOf('http://') != -1) {
//       url = url.replace('http://', 'https://');
//     }
//     fetch(url, {
//       method: 'GET',
//       cache: 'no-cache',
//     }).then((res) => {
//       const fileStream = streamSaver.createWriteStream(`${name}.mp4`, {
//         size: res.headers.get('content-length'),
//       });
//       const readableStream = res.body;
//       // more optimized
//       if (window.WritableStream && readableStream.pipeTo) {
//         return readableStream.pipeTo(fileStream)
//           .then(() => console.log('done writing'));
//       }
//       window.writer = fileStream.getWriter();
//
//       const reader = res.body.getReader();
//       const pump = () => reader.read()
//         .then(res => (res.done
//           ? window.writer.close()
//           : window.writer.write(res.value).then(pump)));
//
//       pump();
//     });
//   },
// };
export default Common;



// WEBPACK FOOTER //
// ./src/utils/common.js